import React from "react";
import { Text } from "~/components/Text";
import type { ViewProps } from "~/components/View";
import { View } from "~/components/View";
import { styleConstants as C } from "~/style/styleConstants";
import { IconButton } from "./IconButton";
import type { IconButtonProps } from "./IconButton";

export interface IconButtonWithBadgeProps extends IconButtonProps {
  count?: number;
  shouldShowBadge: boolean;
  badgeStyle?: ViewProps["style"];
}

export function IconButtonWithBadge({
  iconSize = 28,
  iconColor = C.colorTextLight,
  iconName,
  shouldShowBadge,
  badgeStyle: badgeStyleProps,
  count,
  onPress,
  ...props
}: IconButtonWithBadgeProps) {
  const badgeSize = iconSize * 0.4;
  const badgeRadius = badgeSize * 0.5;
  const badgeStyle: ViewProps["style"] = {
    position: "absolute",
    width: badgeSize,
    height: badgeSize,
    backgroundColor: C.colorTextDanger,
    borderRadius: badgeRadius,
    right: iconSize * 0.4,
    top: iconSize * 0.6,
  };

  const shouldShowCount = typeof count === "number";

  return (
    <View>
      <IconButton
        iconSize={iconSize}
        iconColor={iconColor}
        iconName={iconName}
        onPress={onPress}
        {...props}
      />
      {shouldShowBadge && (
        <View centerContent style={[badgeStyle, badgeStyleProps]}>
          {shouldShowCount && (
            <Text colorLight weightSemiBold sizeExtraSmall>
              {count}
            </Text>
          )}
        </View>
      )}
    </View>
  );
}
